<template>
    <div>
        <Breadcrumbs main="Admin" submain="Portfolio" title="Messages" />
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                     
    
                        <div class="card-body">
                            <b-row>
                                <b-col xl="6">
                                    <b-input-group class="datatable-btn">
                                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-col>
    
                                <b-col xl="6">
                                    <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                        <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
    
                            <div v-if="!loading && !error">
                                <div class="table-responsive datatable-vue">
                                    <b-table show-empty stacked="md" :items="contact_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                        <template #cell(index)="data">
                                            {{ (currentPage - 1) * perPage + data.index + 1 }}
                                        </template>
    
                                        <template #cell(image)="row">
                                            <img :src="host+row.item.image" alt="" style="width: 120px; height: 80px;">
                                        </template>
    
                                        <template #cell(title)="row">
                                            <div v-if="row.item.title">
                                                <p>{{ row.item.title }}</p>
                                            </div>
                                        </template>

                                        <template #cell(description)="row">
                                            <div v-if="row.item.description">
                                                <p>{{ row.item.description }}</p>
                                            </div>
                                        </template>
    
                                        <!-- <template #cell(link)="row">
                                            <div v-if="row.item.link">
                                                <a :href="row.item.link" target="_blank" class="link-style">{{ row.item.link.substring(0,40) }}</a>
                                            </div>
                                            <div v-else>
                                                N/A
                                            </div>
                                        </template> -->
    
                                        <template #cell(action)="data">
                                            <span style="display: flex; gap: 12px;">
                                                <div>
                                                    <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteContact(data.item.id)" title="Delete"></feather>
                                                </div>
    
                                                <div @click="viewContact(data.item)">
                                                    <feather type="eye" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="View" v-b-modal.modal-prevent-closing-edit></feather>
                                                </div>
                                            </span>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
    
                            <div v-else>
                                <loader />
                            </div>
    
                            <b-col md="6" class="my-1 p-0">
                                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                            </b-col>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    

        <!-- Contact Edit Modal -->
        <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Appearance" size="lg" @show="resetEditModal" @hidden="resetEditModal">
            <form ref="form" >
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Subject</label>
                            <input class="form-control" type="text" placeholder="Subject" v-model="edit_contact.subject">
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Name</label>
                            <input class="form-control" type="text" placeholder="Enter contact name" v-model="edit_contact.name">
                        </div>
                    </div>
                </div>
    
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Email</label>
                            <input class="form-control" type="text" placeholder="Enter email" v-model="edit_contact.email">
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Phone</label>
                            <input class="form-control" type="text" placeholder="Enter phone" v-model="edit_contact.phone">
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Message</label>
                            <textarea class="form-control" v-model="edit_contact.message" id="" rows="8"></textarea>
                          
                        </div>
                    </div>
                  
                </div>

    
               
            </form>
        </b-modal>
 
    
        <!-- Contact Delete Modal -->
        <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
            <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this message?</div>
        </b-modal>
    </div>
</template>
    
<script>
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import Datepicker from 'vuejs-datepicker';
    import Swal from 'sweetalert2/dist/sweetalert2.js';
    import 'sweetalert2/src/sweetalert2.scss';
    import moment from "moment";
    import { mapState } from 'vuex';
    import { myHost } from '../../../_helpers/host';
    import js from '../../../auth/js';
    import loader from '../loader/loader.vue';
    
    export default {
        components: {
            Datepicker,
            loader
        },
    
        data() {
            return {
                editor: ClassicEditor,
                host: myHost.host,
                tablefields: [
                    {
                        key: 'index',
                        label: '#'
                    },
                    {
                        key: 'name',
                        label: 'Name',
                        sortable: true
                    },
                    {
                        key: 'email',
                        label: 'Email',
                        sortable: true
                    },
                    {
                        key: 'phone',
                        label: 'Phone',
                        sortable: true
                    },
                    {
                        key: 'subject',
                        label: 'Subject',
                        sortable: true
                    },
                    {
                        key: 'action',
                        label: 'Action',
                        sortable: false
                    }
                ],
    
              
                edit_contact: {
                    id: '',
                    name: '',
                    email: '',
                    phone: '',
                    message: '',
                    subject:'',
                },
    
                show_image: null,
                delete_value: null,
    
                filter: null,
                totalRows: 1,
                currentPage: 1,
                perPage: 10,
                pageOptions: [5, 10, 15]
            };
        },
    
        computed: {
            ...mapState({
                contact_list: state => state.contact.contact,
                loading: state => state.contact.contactLoading,
                error: state => state.contact.contactError
            }),
    
            sortOptions() {
                // Create an options list from our fields
                return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
            }
        },
    
        mounted() {
            this.$store.dispatch("contact/fetchContact").then(() => {
                this.items = this.contact_list
                this.totalRows = this.items.length;
            });
        },
    
        methods: {

            viewContact(detail) {
                this.edit_contact.id = detail.id ? detail.id : null
                this.edit_contact.subject = detail.subject ? detail.subject : null
                this.edit_contact.name = detail.name ? detail.name : null
                this.edit_contact.email = detail.email ? detail.email : null
                this.edit_contact.phone = detail.phone ? detail.phone : null
                this.edit_contact.message= detail.message ? detail.message : null
         
            },
    
            resetEditModal() {
                this.edit_contact.id =  null
                this.edit_contact.subject =  null
                this.edit_contact.name =  null
                this.edit_contact.email =  null
                this.edit_contact.phone =  null
                this.edit_contact.message= null
               
            },
           
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },
    
          

    
            deleteContact(id) {
                this.delete_value = id
            },
    
            handleDeleteOk() {
                this.$store.dispatch("contact/deleteContact", {
                    delete: this.delete_value
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.delete_value = null
    
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
            }
        }
    };
</script>
    